import React from 'react';

import { useAppContext, useFreecodeContext } from 'hooks/useContext';
import { categories } from 'util/appConstants';
import ResizableColumns from 'components/ResizableColumns/ResizableColumns';
import { ConsoleContainer, ConsoleText, BoldHover } from './styles';
import ExerciseProgress from '../ExerciseProgress/ExerciseProgress';

export default function Console() {
  const { isDarkMode } = useAppContext();
  const { test } = useFreecodeContext();

  // TODO implement run options
  const runCode = () => alert('Run not implemented');

  // Initial display before the first run code
  const initialDisplay = (
    <ConsoleText isDarkMode={isDarkMode}>
      Your program output appears here.
      <br />
      Click on{' '}
      <i onClick={runCode}>
        <BoldHover>Run Code</BoldHover>
      </i>{' '}
      to execute
    </ConsoleText>
  );

  const consoleDisplay = () => <ConsoleContainer>{initialDisplay}</ConsoleContainer>;

  const exerciseDisplay = () => (
    <ResizableColumns sizes={[75, 25]}>
      {consoleDisplay()}
      <ExerciseProgress />
    </ResizableColumns>
  );

  return categories.EXERCISE.category === test.category ? exerciseDisplay() : consoleDisplay();
}
